"use client"

import { SlidersVertical } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SlidersVerticalIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SlidersVerticalIcon = component(Icon)({ as: SlidersVertical })
